import script from "./pSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./pSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./pSwitch.vue?vue&type=style&index=0&id=5becb189&lang=css"

const __exports__ = script;

export default __exports__